import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsOtherNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M31.3 8.181h-6.9a3.57 3.57 0 00-3.159 1.9l-1.8 3.381a.406.406 0 01-.717 0l-5.16-9.7a2.038 2.038 0 00-3.6 0l-1.806 3.4a1.926 1.926 0 01-1.7 1.022H1.019v1.65h5.437a3.571 3.571 0 003.159-1.9l1.81-3.4a.39.39 0 01.687 0l5.16 9.7a2.058 2.058 0 003.631 0l1.8-3.381a1.924 1.924 0 011.7-1.023h6.9z" />
        <path d="M31.3 15.181h-6.9a3.57 3.57 0 00-3.159 1.9l-1.8 3.381a.406.406 0 01-.717 0l-5.16-9.7a2.038 2.038 0 00-3.6 0l-1.81 3.406a1.925 1.925 0 01-1.7 1.022H1.019v1.65h5.437a3.57 3.57 0 003.159-1.9l1.81-3.4a.39.39 0 01.687 0l5.16 9.7a2.058 2.058 0 003.631 0l1.8-3.381a1.924 1.924 0 011.7-1.023h6.9z" />
        <path d="M21.244 24.08l-1.8 3.38a.406.406 0 01-.717 0l-5.16-9.7a2.039 2.039 0 00-3.6 0l-1.81 3.406a1.927 1.927 0 01-1.7 1.022H1.019v1.65h5.437a3.572 3.572 0 003.159-1.9l1.81-3.405a.39.39 0 01.687 0l5.16 9.7a2.057 2.057 0 003.631 0l1.8-3.38a1.924 1.924 0 011.7-1.024h6.9v-1.65H24.4a3.57 3.57 0 00-3.156 1.9z" />
      </g>
    </svg>
  )
);
SvgSportsOtherNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsOtherNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsOtherNormalMedium;
